<template>
    <v-card class="ma-2 font-weight-black text-center rounded-xl" style="display: flex;justify-content: center;align-content: center;"
            :style="{'padding':((isServed?16*ratio:10*ratio)+'px;'),width: (isServed?200*ratio:150*ratio)+'px',height:(isServed?140*ratio:100*ratio) +'px',}"
            :class="{'white--text green':(index===0&&isServed),'black--text white':!(index===0&&isServed),'display-3':true,}"
    >
      <span style="align-self: center;" :style="{'font-size': (100*ratio)+'%'}">{{ order.pickUpNumber }}</span>
    </v-card>
</template>

<script>
export default {
  name: "Order",
  props: {
    order: Object,
    isServed: Boolean,
    index: Number,
    ratio:Number,
  },
};
</script>
